// extracted by mini-css-extract-plugin
export default {"contato":"Contato_contato__t-nnO","container":"Contato_container__RBb72","links":"Contato_links__+K+T5","btnContato":"Contato_btnContato__v+W-f","copy":"Contato_copy__msVlw"};